import React, { useContext, useEffect, useState } from 'react'
import './header.less'
import {
    MenuOutlined
} from '@ant-design/icons'
import { ReactComponent as LogoSvg } from './icons/logo.svg';
import { ReactComponent as UploadSvg } from './icons/upload.svg';
import { ReactComponent as InspectSvg } from './icons/inspect.svg';
import { ReactComponent as StatsSvg } from './icons/stats.svg';
import { ReactComponent as TaskSvg } from './icons/task.svg';
import { ReactComponent as NoticeSvg } from './icons/notice.svg';
import classNames from 'classnames';
import { Building } from '@/commons/interface/project/building';
import { Select } from 'antd';
import { MODEL_TYPE_LIST } from '@/commons/enums/model-file-type';
import { useParams } from 'react-router';
import { DetailType } from '@/commons/enums/detail-type';
import { SystemStatus } from '@/commons/context/system-store';
import { SystemContext } from '@/App';

interface Iprops {
    toggleSideShow: () => void
    activeModelType: number
    toggleActiveModel: (type: number) => void
    buildings?: Building[]
    activeBuildingUuid?: string
    changeBuilding: (buildingUuid: string) => void
}

export default function ProjectHeader(props: Iprops) {

    const { buildingUuid } = useParams()

    // const [selectedDetail, setSelectedDetail] = useState<number>(null); // 选中的详情面板
    const systemContext = useContext<SystemStatus>(SystemContext);

    // let btnArr = [
    //     {name: '建筑', type: 1},
    //     {name: '结构', type: 2},
    //     {name: '给排水', type: 3},
    //     {name: '空调', type: 4},
    //     {name: '电气', type: 5},
    //     {name: '消防', type: 6},
    // ]

    useEffect(() => {
        if (props.buildings != null) {

        }
    }, [props.buildings])

    const handleType = (type: number) => {
        if (systemContext.currentDetailType == type) {
            // 取消选中
            // setSelectedDetail(null);
            systemContext.setCurrentDetailType(null);
        } else {
            // setSelectedDetail(type);
            systemContext.setCurrentDetailType(type);
        }
    }

    return (
        <div className='project-header-container'>
            <div className='left-side-icon' onClick={() => {
                props.toggleSideShow?.();
            }}>
                <MenuOutlined className='icon' />
            </div>
            <div className='logo'>
                <div className='logo-font'>
                    <LogoSvg />
                </div>
            </div>

            <div className='building'>
                <div className='indicator'>·</div>
                <Select className='building-select' popupMatchSelectWidth={false} value={props.activeBuildingUuid} onChange={(value) => props.changeBuilding?.(value)}>
                    {props.buildings?.map((building, idx) => (
                        <Select.Option key={building.uuid} value={building.uuid}>{building.name}</Select.Option>
                    ))}
                </Select>
            </div>
            <div className='model-major-group'>
                {MODEL_TYPE_LIST.map(btn => (
                    <div className={classNames({
                        'model-major-btn': true,
                        'active': props.activeModelType === btn.value,
                        'disable': buildingUuid == "site"
                    })} onClick={() => {
                        if (buildingUuid == "site") return
                        props.toggleActiveModel?.(btn.value)
                    }}>
                        {btn.label}
                    </div>
                ))}
            </div>
            <span className='fill-remaining-space'></span>
            <div className='right-icon-group'>
                <div className={classNames({
                    'icon-btn': true,
                    'selected': systemContext.currentDetailType == DetailType.UPLOAD,
                })} onClick={() => handleType(DetailType.UPLOAD)}>
                    <UploadSvg />
                </div>
                <div className={classNames({
                    'icon-btn': true,
                    'selected': systemContext.currentDetailType == DetailType.INSPECT,
                })} onClick={() => handleType(DetailType.INSPECT)}>
                    <InspectSvg />
                </div>
                <div className={classNames({
                    'icon-btn': true,
                    'selected': systemContext.currentDetailType == DetailType.DEVICE_STATUS,
                })} onClick={() => handleType(DetailType.DEVICE_STATUS)}>
                    <StatsSvg />
                </div>
                <div className={classNames({
                    'icon-btn': true,
                    'selected': systemContext.currentDetailType == DetailType.SEND_TASK,
                })} onClick={() => handleType(DetailType.SEND_TASK)}>
                    <TaskSvg />
                </div>
                <div className={classNames({
                    'icon-btn': true,
                    'selected': systemContext.currentDetailType == DetailType.NOTICE,
                })} onClick={() => handleType(DetailType.NOTICE)}>
                    <NoticeSvg />
                </div>
            </div>
        </div>
    )
}
